<template>
  <app-modal
    name="vat-return-modal"
    :width="windowWidth <= 1620 ? '90%' : `1328px`"
    :title="$t('vat.tax-filing-support')"
    @before-open="beforeOpen"
    hide-footer
  >
    <div class="d-flex flex-column justify-content-center align-items-center">
      <h4 class="text-uppercase font-weight-bolder">
        {{ $t('vat.form.title.VATReturn') }}
      </h4>
      <p class="text-sm">({{ $t('vat.form.description') }})</p>
      <p class="text-sm text-primary">
        [01a] {{ $t('vat.form.01.a.label') }}:
        <span v-if="formModel.ten_NganhNghe">
          {{ formModel.ten_NganhNghe }}
        </span>
      </p>
      <p class="text-sm text-primary">
        [01b] {{ $t('vat.form.01.b.label') }}: {{generateDate()}}
      </p>
      <div class="d-flex flex-row gap-15 text-sm text-primary">
        <p>
          [02] {{ $t('vat.form.02.label') }}
          <span v-if="!formModel.TKhaiThueSoLan" class="ml-1 px-2 border">X</span>
        </p>
        <p>
          [03] {{ $t('vat.form.03.label') }}
          <span v-if="!!formModel.TKhaiThueSoLan" class="ml-1 px-2 border">
            {{ formModel.TKhaiThueSoLan }}
          </span>
        </p>
      </div>
    </div>
    <div class="grid grid-cols-2">
      <div class="col-span-1 lg-col-span-2 d-flex flex-column">
        <div class="grid grid-cols-2 text-sm text-primary">
          <p>[04] {{ $t('vat.form.04.label') }}:</p>
          <p v-if="company.full_name">
            {{ company.full_name.toUpperCase() }}
          </p>
        </div>
        <div class="grid grid-cols-2 text-sm text-primary">
          <p>[05] {{ $t('vat.form.05.label') }}:</p>
          <p v-if="company.tax_code">
            {{ company.tax_code }}
          </p>
        </div>
        <div class="grid grid-cols-2 text-sm text-primary">
          <p>[06] {{ $t('vat.form.06.label') }}:</p>
          <p v-if="formModel.tenCQTNoiNop">
            {{ formModel.tenCQTNoiNop }}
          </p>
        </div>
        <div class="grid grid-cols-2 text-sm text-primary">
          <p>[07] {{ $t('vat.form.07.label') }}:</p>
          <p v-if="formModel.maCQTNoiNop">
            {{ formModel.maCQTNoiNop }}
          </p>
        </div>
        <div class="grid grid-cols-2 text-sm text-primary">
          <p>[08] {{ $t('vat.form.08.label') }}:</p>
          <p></p>
        </div>
      </div>
    </div>
    <VatReturnForm ref="form">
      <vat-return-table
        ref="table"
        :default-data="defaultData"
      />
    </VatReturnForm>
    <div class="pt-3 pr-4 text-right">
      <app-btn-submit
        :css="'btn btn-primary btn-sm ml-2'"
        :text="$t('vat.form.actions.export')"
        :isSubmitting="isLoading"
        @on-click="onSubmit"
      />
    </div>
  </app-modal>
</template>
<script>
import ToastUtils from '@/utils/toast';
import {
  downloadFile,
  getFilenameFromResponse,
} from '@/utils/download';
import AppModal from '@/components/app-modal';
import AppBtnSubmit from '@/components/app-button';
import InvoiceProxy from '@/store/proxies/invoice-proxy';
import { VatReturnForm } from '../vat-return-form';
import { VatReturnTable } from '../vat-return-table';
import { getAllCtFields } from './index';

const getCompany = () => {
  const currentUser = JSON.parse(localStorage.getItem('currentUser'));
  const company = currentUser.company;
  if (company) {
    return company;
  }
  return null;
};

export default {
  name: 'VatReturnModal',
  components: { AppBtnSubmit, VatReturnTable, VatReturnForm, AppModal },
  data() {
    return {
      isLoading: false,
      windowWidth: window.innerWidth,
      company: getCompany(),
      formModel: {},
      defaultData: {},
    };
  },
  methods: {
    generateDate() {
      if (!this.formModel.kyKKhai) return '';
      let result = '';
      const arrDate = this.formModel.kyKKhai.split('/');
      if (this.formModel.kieuKy === 'M') {
        result += `${this.$t('app.month')} ${arrDate[0]}`;
      } else if (this.formModel.kieuKy === 'Q') {
        result += `Quý ${arrDate[0]}`;
      }
      return `${result} ${this.$t('app.year').toLowerCase()} ${arrDate[1]}`;
    },
    getDataTaxDeduction() {
      new InvoiceProxy()
        .getDataTaxDeduction({
          kieuKy: this.formModel.kieuKy,
          kyKKhai: this.formModel.kyKKhai,
        })
        .then((res) => {
          if (res) {
            const ctFields = getAllCtFields(res);
            this.defaultData = { ...ctFields };
          }
        })
        .catch((error) => {
          ToastUtils.showToast('error', error.message || error);
        });
    },
    beforeOpen(params) {
      this.formModel = params.model;
      this.getDataTaxDeduction();
    },
    onSubmit() {
      const vm = this;
      const form = vm.$refs.form.getValues();
      const table = vm.$refs.table.getValues();

      const payload = {
        ...this.formModel,
        ...form,
        ...table,
      };
      this.isLoading = true;
      new InvoiceProxy().generateXMLTaxDeclaration(payload)
        .then((res) => {
          if (res && res.data) {
            downloadFile(
              getFilenameFromResponse(res),
              res.data,
              { type: res.data.type },
            );
          }
        })
        .catch(err => ToastUtils.showToast('error', err.message || err))
        .finally(() => { this.isLoading = false; });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/portal-components/value-added-tax/vat-return/vat-return-modal/vat-return-modal.vue